var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"app-permissions-warning"},[_c('alert-svg'),_vm._v(" You don't have permissions to all products. Contact a content manager. ")],1)}
var staticRenderFns = []

export { render, staticRenderFns }